import { InstalledBuilderElement } from "@builder/store/slices/builderElementsInstalledApiSlice";
import { addNodeUIReactions } from "@builder/store/slices/BuilderSlice/builderHelpers";
import { getComponent } from "@builder/store/slices/BuilderSlice/builderMap";
import { addNode, moveNode, selectNode, setDraggedNode, setDraggedUIComponent, setHovered } from "@builder/store/slices/BuilderSlice/builderSlice";
import store from "@builder/store/store";
import { BuildComponentKey } from "@common/build/types";
import { DragEvent } from "react";
import { getElementToAdd } from "../../AddElement/helper";

const emptyImage = new Image(0, 0);
emptyImage.src = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7";

export function startDragging(e: DragEvent) {
    const node = e.target as HTMLElement;
    store.dispatch(setDraggedNode(node.id));
    e.stopPropagation();
    e.dataTransfer.setDragImage(emptyImage, 0, 0);
    node.style.opacity = "0.5";
}

function binarySearch(array: number[], value: number) {
    let start = 0;
    let end = array.length - 1;

    while (start <= end) {
        const mid = Math.floor((start + end) / 2);
        if (array[mid] === value) return mid;
        else if (array[mid] < value) start = mid + 1;
        else end = mid - 1;
    }

    return start;
}

/**
 * where mouse is relative to parent div, as an index of child
 */
function indexInDiv(e: DragEvent, div: HTMLElement): { deIdx: number; deOffsetDirection: "left" | "top" } | undefined {
    const direction = div?.style?.flexDirection || "column";

    const mousePos = direction === "row" ? e.clientX : e.clientY;
    const offsetProp = direction === "row" ? "left" : "top";

    const childrenOffsets = [...div.children]
        .filter(child => child.id !== store.getState().builder.draggedNode)
        .map(child => child.getBoundingClientRect()[offsetProp] + child.getBoundingClientRect()[direction === "row" ? "width" : "height"] / 2);

    if (childrenOffsets.length === 0) return { deIdx: 0, deOffsetDirection: offsetProp };
    const deIdx = binarySearch(childrenOffsets, mousePos);

    return { deIdx, deOffsetDirection: offsetProp };
}

export function whileDraggingOverMe(e: DragEvent, targetID: string, div: HTMLElement) {
    e.preventDefault();

    const draggedNode = store.getState().builder.draggedNode;
    const draggedUIComponent = store.getState().builder.draggedUIComponent;
    if (!draggedNode && !draggedUIComponent) return;

    const draggedID = store.getState().builder.draggedNode;

    if (draggedID == targetID) return;

    const recommendedIdx = indexInDiv(e, div);
    if (!recommendedIdx) return;
    const { deIdx, deOffsetDirection } = recommendedIdx;
    store.dispatch(setHovered({ id: targetID, childIndex: deIdx, direction: deOffsetDirection }));
}

export function endDragging(e: DragEvent) {
    e.preventDefault();
    e.stopPropagation();
    const draggedNode = store.getState().builder.draggedNode;
    const hoveredNodeID = store.getState().builder.hoveredNode.id;
    if (!draggedNode) return;
    if (!hoveredNodeID) {
        store.dispatch(setDraggedNode(null));
        (e.target as HTMLElement).style.opacity = "1";

        return;
    }

    const idx = store.getState().builder.hoveredNode.childIndex;

    store.dispatch(moveNode({ nodeId: draggedNode, targetId: hoveredNodeID, index: typeof idx === "number" ? idx : undefined }));
    (e.target as HTMLElement).style.opacity = "1";

    store.dispatch(selectNode(hoveredNodeID));
    store.dispatch(setDraggedNode(null));
    store.dispatch(setHovered({ id: null, childIndex: null, direction: null }));
}

//for adding NEW elements
export const handleUIdragStart = (e: React.DragEvent, key: BuildComponentKey, dynamicElement?: InstalledBuilderElement) => {
    e.stopPropagation();
    e.dataTransfer.setDragImage(emptyImage, 0, 0);
    store.dispatch(setDraggedUIComponent({ key, dynamicElement }));
};

export const handleUIdragEnd = (e: React.DragEvent, key: BuildComponentKey, dynamicElement?: InstalledBuilderElement) => {
    e.stopPropagation();
    const elemToAdd = getComponent(key as BuildComponentKey);
    const hoveredNode = store.getState().builder.hoveredNode;
    if (hoveredNode.id) {
        store.dispatch(addNode({ node: getElementToAdd(key, dynamicElement), index: hoveredNode.childIndex! }));
        addNodeUIReactions(elemToAdd);
    }
    store.dispatch(setDraggedUIComponent(null));
    store.dispatch(setHovered({ id: null, childIndex: null, direction: null }));
};
